module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', {
    staticClass: "toolbar",
    staticStyle: {
      "padding": "10px 0px",
      "background": "#f5f7f9"
    },
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover",
      "body-style": {
        height: '100px'
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("今日新增用户")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.summary.today_news_user))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover",
      "body-style": {
        height: '100px'
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("今日活跃用户")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.summary.today_dau_user))])])])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 8
    }
  }, [_c('el-card', {
    attrs: {
      "shadow": "hover",
      "body-style": {
        height: '100px'
      }
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_vm._v("今日注册用户")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "font-size": "30px"
    }
  }, [_vm._v(_vm._s(_vm.summary.today_register_user))])])])], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true
    }
  }, [_c('el-form-item', [_c('el-select', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "size": "small",
      "clearable": "",
      "placeholder": "请选择"
    },
    on: {
      "change": _vm.handChange
    },
    model: {
      value: (_vm.field),
      callback: function($$v) {
        _vm.field = $$v
      },
      expression: "field"
    }
  }, [_c('el-option', {
    key: "1",
    attrs: {
      "label": "设备号",
      "value": "device_id"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "2",
    attrs: {
      "label": "手机号",
      "value": "phone"
    }
  }), _vm._v(" "), _c('el-option', {
    key: "3",
    attrs: {
      "label": "推广码",
      "value": "code"
    }
  })], 1), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "size": "small",
      "placeholder": _vm.placeholder
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "label": "序号",
      "width": "50"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "device_id",
      "label": "设备号",
      "align": "center",
      "width": "180"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机号",
      "align": "center",
      "width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "等级",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tag', {
          attrs: {
            "size": "small",
            "type": "warning"
          }
        }, [_vm._v(_vm._s(_vm.formatLevel(scope.row.level)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "watch_num",
      "label": "次数",
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cache_num",
      "label": "次数",
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "spread_num",
      "label": "人数",
      "align": "center",
      "min-width": "80"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "code",
      "label": "推广",
      "align": "center",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "date",
      "label": "创建时间",
      "align": "center",
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "align": "center",
      "width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "plain": "",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#909399"
          },
          attrs: {
            "type": "text",
            "size": "mini"
          },
          on: {
            "click": function($event) {
              return _vm.ToDetail(scope.row)
            }
          }
        }, [_vm._v("展开详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-button', {
    attrs: {
      "type": "danger",
      "disabled": this.sels.length === 0
    },
    on: {
      "click": _vm.batchRemove
    }
  }, [_vm._v("批量删除")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "width": "45%",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "用户名称"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "disabled": "",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.username),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "username", $$v)
      },
      expression: "editForm.username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "观看次数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": -1
    },
    model: {
      value: (_vm.editForm.watch_num),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "watch_num", $$v)
      },
      expression: "editForm.watch_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "缓存次数"
    }
  }, [_c('el-input-number', {
    attrs: {
      "min": 0
    },
    model: {
      value: (_vm.editForm.cache_num),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "cache_num", $$v)
      },
      expression: "editForm.cache_num"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "等级设置"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.level),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "level", $$v)
      },
      expression: "editForm.level"
    }
  }, _vm._l((_vm.levellist), function(item) {
    return _c('el-radio', {
      key: item.id,
      attrs: {
        "label": item.level
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f3c7dff"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/user.vue
// module id = 1094
// module chunks = 36